import React from 'react';
import { useSolanaWallets } from '../hooks/useSolanaWallets';
import { WalletAccountContext } from './walletAccountContext';

export function WalletAccountProvider({ children }: { children: React.ReactNode }) {
  const wallet = useSolanaWallets();
  return (
    <WalletAccountContext.Provider value={wallet}>{children}</WalletAccountContext.Provider>
  );
}
